<template>
    <div>
    <SimpleForm api="analyzer" title="Annotation Service Advanced Settings" id="tme-advanced" :fields="fields" @loaded="onLoaded" ref="supportedLanguagesfields"/>
    <otif-table :columns="suported_languages_columns" :paginated="true" :rows="rows" title="Supported Languages" @change="updateSupportedLanguage"/>
</div>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';

const formFields = [
    ['enabled', {component: 'otif-switch'}],
    'name',
    'encoding',
    'otcaServiceMaxAttempts',
    'otcaServiceDelay',
    'otcaSocketTimeout',
    'otcaConnectionTimeout'
];

export default {
    data() {
        return {
            fields: formFields,
            suported_languages_columns: [{
                name: 'code',
                label: 'Supported Language'
            }],
            rows: []
        }
    },

    methods: {
        onLoaded(data) {
            this.rows = data.supportedLanguages.value.map((v) => [v.code]);
            console.log(this.rows);
        },

        updateSupportedLanguage($e) {
            this.$refs['supportedLanguagesfields'].setValue('supportedLanguages', $e.rows.map((row) => {
                return {
                    code: row[0]
                }
            }));
        }
    },

    components: {
        SimpleForm
    }
}

</script>
